import Actions from "../actions";
import { produce } from "immer";

const initialState = {
  walletTransactions: {},
  giftCardTransactions: {},
};

const walletTransactions = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_WALLET_TRANSACTIONS_LIST: {
      draft.walletTransactions = payload?.walletTransactions;
      break;
    }
    case Actions.GET_GIFTCARD_INFO_LIST: {
      draft.giftCardTransactions = payload?.giftInfo;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default walletTransactions;
